/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const WhiteArrowDown = () => {

    return (
        <div className="whiteArrowDown">
            <svg id="whiteArrowDown" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 55.4 66.7" enableBackground="new 0 0 55.4 66.7" xmlSpace="preserve">
                <line className="whiteArrowDown__body" fill="none" stroke="#EAEDF2" strokeWidth="5" strokeLinecap="round" strokeMiterlimit="10" x1="27.7" y1="2.7" x2="27.7" y2="62.9"/>

                <line className="whiteArrowDown__head--left" fill="none" stroke="#EAEDF3" strokeWidth="5" strokeLinecap="round" strokeMiterlimit="10" x1="27.7" y1="63.8" x2="2.7" y2="38.8" />
                <line className="whiteArrowDown__head--right" fill="none" stroke="#EAEDF3" strokeWidth="5" strokeLinecap="round" strokeMiterlimit="10" x1="27.7" y1="63.8" x2="52.7" y2="38.8" />

            </svg>
        </div>
    );
}

export default WhiteArrowDown;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/WhiteArrowDown.jsx